export const buildComment = (call) => {
	if (!call) {
		return '';
	}

	let result = call.result;

	if (call.comment) {
		result += `: ${call.comment}`;
	}

	return result;
};
